import { F as g } from "./chunk-FormElement-DsGY7n6Z.js";
import { f as x } from "./chunk-firstFocusableElement-B5e7Zq7o.js";
import { c as y, a as _, o as v, f as E } from "./chunk-floating-ui.dom-DX1hmIHc.js";
import { a as $, E as p, x as a } from "./chunk-lit-element-D3OkYgeM.js";
import { n } from "./chunk-property---aaewZr.js";
import { r as w } from "./chunk-state-LUQ7lD8m.js";
import { e as b, n as m } from "./chunk-ref-BmrX4-05.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* k(h, e) {
  if (h !== void 0) {
    let t = 0;
    for (const s of h) yield e(s, t++);
  }
}
var S = Object.defineProperty, l = (h, e, t, s) => {
  for (var r = void 0, d = h.length - 1, c; d >= 0; d--)
    (c = h[d]) && (r = c(e, t, r) || r);
  return r && S(e, t, r), r;
}, i;
const o = (i = class extends g {
  constructor() {
    super(), this.iconAssetUrl = window.routes.icons, this.label = "", this.placeholder = "Select an option", this.defaultValue = "", this.alwaysShowPlaceholder = !1, this.error = !1, this._options = [], this.helpText = "", this.errorText = "", this.usePseudoSelectName = !1, this._expanded = !1, this.toggleElement = b(), this.listboxElement = b(), this._cleanupWatcher = null, this._handleDocumentClick = this._handleDocumentClick.bind(this), this._handleDocumentKeyDown = this._handleDocumentKeyDown.bind(this), this._handleClick = this._handleClick.bind(this), this._collectionDataFromChildren();
  }
  _collectionDataFromChildren() {
    const e = Array.from(this.querySelectorAll("option"));
    e.length !== 0 && (this._options = e.map((t) => ({
      label: t.textContent || "",
      value: t.value || "",
      el: t
    })));
  }
  firstUpdated(e) {
    super.firstUpdated(e), document.addEventListener("click", this._handleDocumentClick), document.addEventListener("keydown", this._handleDocumentKeyDown), this._hidePlaceholderElement();
  }
  _hidePlaceholderElement() {
    const e = this.querySelector(
      ".custom-select-placeholder"
    );
    e && (e.style.display = "none", e.remove());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this._handleDocumentClick), document.removeEventListener("keydown", this._handleDocumentKeyDown);
  }
  _handleDocumentClick(e) {
    if (!this.contains(e.target)) {
      this._expanded = !1;
      return;
    }
  }
  _handleClick(e) {
    if (!this._expanded) return;
    const t = this.listboxElement.value, s = e.target;
    if (!t || !s || !t.contains(s)) return;
    const r = s.tagName === "BUTTON" ? s : s.closest("button");
    r && (r.disabled || (this.selectValue(r.value), this.multiple || (this._expanded = !1)));
  }
  // Check if multiple is true, if so, add or remove the value from the array
  // If multiple is false, set the value to the selected value
  selectValue(e) {
    if (this.multiple) {
      const s = new Set(this.parsedValue);
      s.has(e) ? s.delete(e) : s.add(e), this.value = Array.from(s).filter(Boolean).join(",");
    } else
      this.value = e;
    const t = this.querySelector("select");
    t && (t.value = e);
  }
  get currentActiveElement() {
    return this.renderRoot instanceof ShadowRoot ? this.renderRoot.activeElement : document.activeElement;
  }
  _handleDocumentKeyDown(e) {
    if (this._expanded && (e.key === "Escape" && (this._expanded = !1), e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault();
      const t = this.listboxElement.value;
      if (!t) return;
      const s = Array.from(t.querySelectorAll("button")), r = this.currentActiveElement, d = s.findIndex((f) => f === r);
      if (d === -1) {
        s[0].focus();
        return;
      }
      const c = e.key === "ArrowUp" ? d - 1 : d + 1;
      if (c < 0)
        return s[s.length - 1].focus();
      if (c >= s.length)
        return s[0].focus();
      s[c].focus();
    }
  }
  _handleToggleClick() {
    this._expanded = !this._expanded;
  }
  updated(e) {
    const t = this.querySelector("select");
    if (t && this.usePseudoSelectName) {
      const s = `${this.getAttribute("name")}_pseudo`;
      t.setAttribute("name", s);
    }
    super.updated(e), e.has("_expanded") && typeof e.get("_expanded") == "boolean" && this._handleExpandedStateChange();
  }
  _positionListbox(e, t) {
    y(e, t, {
      placement: "bottom-start",
      strategy: "absolute",
      middleware: [
        v(5),
        E({
          crossAxis: !1,
          fallbackPlacements: ["top-start", "bottom-start"],
          fallbackAxisSideDirection: "start"
        })
      ]
    }).then(({ x: s, y: r }) => {
      Object.assign(t.style, {
        right: `${s}px`,
        top: `${r}px`
      });
    });
  }
  async _handleExpandedStateChange() {
    var s;
    if ((s = this._cleanupWatcher) == null || s.call(this), await this.updateComplete, !this._expanded)
      return;
    const e = this.toggleElement.value, t = this.listboxElement.value;
    !e || !t || (this._cleanupWatcher = _(
      e,
      t,
      () => this._positionListbox(e, t)
    ), this._onExpanded());
  }
  _onCollapsed() {
    var e;
    (e = this.toggleElement.value) == null || e.focus(), this.$emit(i.EVENTS.CLOSE, { value: this.value });
  }
  _onExpanded() {
    setTimeout(() => {
      var e;
      this.listboxElement.value && ((e = x(this.listboxElement.value)) == null || e.focus());
    }, 100), this.$emit(i.EVENTS.OPEN, { value: this.value });
  }
  get _processedOptions() {
    const e = this._options, t = this.parsedValue;
    return e.map((s) => ({
      ...s,
      selected: this.multiple && Array.isArray(t) ? t.includes(s.value) : s.value === t
    }));
  }
  get parsedValue() {
    return this.multiple ? String(this.value).split(",") : this.value;
  }
  get idForToggle() {
    return `${this.id}-toggle`;
  }
  get idForListbox() {
    return `${this.id}-listbox`;
  }
  get helpTextHTML() {
    return this.helpText ? a`
      <p id="${this.id}_text" class=${u.HELP_TEXT}>
        ${this.helpText}
      </p>
    ` : p;
  }
  get labelHTML() {
    return a`
      <label for="${this.idForToggle}" class=${u.LABEL}>
        ${this.label}
      </label>
    `;
  }
  getDropdownItemHTML(e) {
    return a`
      <button
        type="button"
        class=${u.DROPDOWN_ITEM}
        role="option"
        aria-selected="${e.selected}"
        value="${e.value}"
        ?selected=${e.selected}
        ?disabled=${e.disabled}
      >
        <span
          class="group-focus:ring-u-focus flex justify-between group-focus-visible:ring-2"
        >
          ${this.renderOptionLabel(e.label, e)}
          ${e.selected ? this.renderSelectedIcon() : p}
        </span>
      </button>
    `;
  }
  renderSelectedIcon() {
    return a`
      <img
        class="block size-3 pt-1"
        src="${this.iconAssetUrl}/icon-checkbox-tick.svg"
      />
    `;
  }
  /**
   * Renders the option label, can be overridden to render custom HTML
   * @param label - The label of the option
   * @param _option - The option object
   * @returns The rendered label
   */
  renderOptionLabel(e, t) {
    return e;
  }
  get hasSelectedOption() {
    return this._processedOptions.some((e) => e.selected);
  }
  get _currentToggleLabel() {
    if (this.alwaysShowPlaceholder || !this.hasSelectedOption)
      return this.placeholder;
    const e = this._processedOptions;
    if (this.multiple)
      return e.filter(
        (r) => r.selected
      ).map((r) => r.label).join(", ");
    const t = e.find((s) => s.selected);
    return this.defaultValue && this.defaultValue !== "" && (t == null ? void 0 : t.value) === this.defaultValue ? this.placeholder : t ? a`
          ${this.placeholder}:
          <span class="text-brand-dark">${t.label}</span>
        ` : this.placeholder;
  }
  get getCustomSelectHTML() {
    return a`
      <div
        class="group peer relative w-full"
        ?error=${this.error}
        ?open=${this._expanded}
        @click=${this._handleClick}
      >
        <button
          ${m(this.toggleElement)}
          type="button"
          role="combobox"
          @click=${this._handleToggleClick}
          aria-haspopup="listbox"
          class="relative"
          id="${this.idForToggle}"
          value="${this.value}"
          aria-label="${this._currentToggleLabel}"
          aria-controls="${this.idForListbox}"
          aria-expanded="${this._expanded}"
          aria-disabled="${this.disabled}"
          ?disabled=${this.disabled}
          ${this.helpText ? `aria-describedby="${this.id}_text"` : ""}
          class=${u.TOGGLE}
        >
          <span class="text-brand-darkest block truncate pr-4"
            >${this._currentToggleLabel}</span
          >
          <div class=${u.TOGGLE_ICON}>
            <img
              class="${this._expanded ? "rotate-180" : ""} block size-3 transition-transform duration-300"
              src="${this.iconAssetUrl}/icon-select-arrow.svg"
              alt=""
            />
          </div>
        </button>

        <div
          ${m(this.listboxElement)}
          id="dropdown"
          role="listbox"
          id="${this.idForListbox}"
          ?inert=${!this._expanded}
          class=${u.DROPDOWN}
          ${this.multiple ? 'aria-multiselectable="true"' : ""}
        >
          ${k(
      this._processedOptions,
      (e) => this.getDropdownItemHTML(e)
    )}
        </div>
      </div>
      ${this.helpTextHTML}
    `;
  }
  get getNativeSelectHTML() {
    return a`<slot></slot>`;
  }
  render() {
    return !Array.isArray(this._options) || this._options.length === 0 ? a`${p}` : this.getCustomSelectHTML;
  }
}, i.EVENTS = {
  OPEN: "open",
  CLOSE: "close"
}, i.styles = [
  $`
      @starting-style {
        .custom-select__dropdown {
          opacity: 0 !important;
          transform: translateY(2rem) !important;
        }
      }
    `
], i);
l([
  n({ type: String })
], o.prototype, "label");
l([
  n({ type: String })
], o.prototype, "placeholder");
l([
  n({ type: String, attribute: "default-value" })
], o.prototype, "defaultValue");
l([
  n({ type: Boolean, attribute: "always-show-placeholder" })
], o.prototype, "alwaysShowPlaceholder");
l([
  n({ type: Boolean })
], o.prototype, "error");
l([
  n({ type: Array, attribute: "options" })
], o.prototype, "_options");
l([
  n({ type: String })
], o.prototype, "helpText");
l([
  n({ type: String })
], o.prototype, "errorText");
l([
  n({ type: Boolean, attribute: "use-pseudo-name" })
], o.prototype, "usePseudoSelectName");
l([
  w()
], o.prototype, "_expanded");
let T = o;
customElements.get("custom-select") || customElements.define("custom-select", T);
const u = {
  TOGGLE: "text-left block bg-c-form-bg w-full min-w-14 border-none appearance-none text-brand-darkest disabled:text-neutral rounded-xs h-10 p bg-gray-50 bg-transparent focus:outline-hidden focus:ring-0 peer group-[[error]]:ring-brand-error group-[[error]]:ring-2 focus-visible:ring-2 focus-visible:ring-u-focus",
  TOGGLE_ICON: "absolute top-3.5 size-3 right-0 pointer-events-none text-brand-darkest group-[[error]]:text-brand-error",
  LABEL: "absolute caption text-sm text-brand-darkest duration-300 transform -translate-y-2.5 cursor-pointer top-1/2 start-2.5 lg:start-2.5 z-10 origin-[0] peer-focus:text-brand-darkest peer-disabled:text-neutral peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-2.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto",
  HELP_TEXT: "caption text-brand-dark start-2.5 lg:start-2.5",
  DROPDOWN: "custom-select__dropdown md:min-w-max bg-c-form-bg max-h-[50vh] overflow-y-auto overflow-x-clip scrollbar-none scrollbar-track-[transparent] scrollbar-thumb-brand-neutral absolute z-20 hidden top-full right-0 w-full border border-brand-neutral bg-brand-lightest drop-shadow-md rounded-xs group-[[open]]:grid translate-y-4 opacity-0 transition-[opacity,display,transform] [transition-behavior:allow-discrete] motion-reduce:transition-none duration-300 group-[[open]]:translate-y-0 group-[[open]]:opacity-100 !motion-reduce:group-[[open]]:transition-none",
  DROPDOWN_ITEM: "px-4 group min-w-[212px] ring-0 focus:ring-0 appearance-none outline-hidden py-2.5 bg-white body-text disabled:text-brand-neutral text-brand-darkest  focus-visible:text-brand-darkest hover:bg-neutral hover:text-brand-darkest disabled:hover:text-brand-neutral text-left border-b border-brand-neutral last:border-b-0 border-solid"
};
export {
  T as CustomSelect
};
